import {onBreadcrumbClick} from '../../components/common/di-ding/_nav-maps'

export const routeNameOfDi = {
  ELECTRONIC_IMPORT: 'electronic-import',
  ELECTRONIC_RECORD: 'electronic-record',
}

export const commonConfig = {
  firstBreadcrumb: {
    label: '智慧用电',
    onClick: onBreadcrumbClick
  }
}



// WEBPACK FOOTER //
// ./src/view/ElectronicControl/common.js